import api from './api';

// Servicio de productos
export const productsService = {
  // Obtener todos los productos con paginación
  getAll: async (page = 1, limit = 40, search = '', category = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      
      if (search) params.append('search', search);
      if (category) params.append('category', category);
      
      console.log('🔍 Llamando API productos con params:', params.toString());
      
      const response = await api.get(`/products?${params.toString()}`);
      
      console.log('📦 Respuesta API productos:', response.data);
      
      return response.data; // Retorna { success, data, pagination }
    } catch (error) {
      console.error('❌ Error en productsService.getAll:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo productos');
    }
  },

  // Obtener todos los productos sin paginación (para formularios)
  getAllUnpaginated: async () => {
    try {
      const response = await api.get('/products?limit=10000');
      // Retornar directamente el array para consistencia con otros lugares
      return response.data.data || response.data || [];
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo productos');
    }
  },

  // Obtener producto por ID
  getById: async (id) => {
    try {
      console.log('🔍 Obteniendo producto por ID:', id);
      const response = await api.get(`/products/${id}`);
      console.log('📦 Respuesta getById:', response.data);
      
      // Extraer el producto de la respuesta
      if (response.data.success && response.data.data) {
        return response.data.data;
      } else if (response.data && !response.data.success) {
        throw new Error(response.data.error || 'Producto no encontrado');
      } else {
        return response.data; // Por compatibilidad
      }
    } catch (error) {
      console.error('❌ Error en getById:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo producto');
    }
  },

  // Crear nuevo producto
  create: async (productData) => {
    try {
      console.log('📝 Creando producto con datos:', productData);
      const response = await api.post('/products', productData);
      console.log('✅ Respuesta crear producto:', response.data);
      return response.data; // Retorna toda la respuesta para manejar structure correctamente
    } catch (error) {
      console.error('❌ Error creando producto:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error creando producto');
    }
  },

  // Actualizar producto
  update: async (id, productData) => {
    try {
      console.log('🔄 Actualizando producto:', id, 'con datos:', productData);
      const response = await api.put(`/products/${id}`, productData);
      console.log('✅ Respuesta actualizar producto:', response.data);
      return response.data; // Retorna toda la respuesta para manejar estructura correctamente
    } catch (error) {
      console.error('❌ Error actualizando producto:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando producto');
    }
  },

  // Eliminar producto
  delete: async (id) => {
    try {
      const response = await api.delete(`/products/${id}`);
      return response.data; // El delete puede retornar solo success
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error eliminando producto');
    }
  },

  // Obtener productos con stock bajo
  getLowStock: async () => {
    try {
      const response = await api.get('/products/reports/low-stock');
      return response.data.data; // Extraer el array del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo productos con stock bajo');
    }
  },

  // ===== MÉTODOS PARA GESTIÓN DE SKUs MÚLTIPLES =====

  // Obtener SKUs de un producto
  getProductSkus: async (productId) => {
    try {
      const response = await api.get(`/products/${productId}/skus`);
      return response.data; // Retorna { success, data }
    } catch (error) {
      console.error('❌ Error obteniendo SKUs del producto:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo SKUs');
    }
  },

  // Agregar SKU a un producto
  addProductSku: async (productId, skuData) => {
    try {
      const response = await api.post(`/products/${productId}/skus`, skuData);
      return response.data; // Retorna { success, message, data }
    } catch (error) {
      console.error('❌ Error agregando SKU:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error agregando SKU');
    }
  },

  // Actualizar SKU de un producto
  updateProductSku: async (productId, skuId, skuData) => {
    try {
      const response = await api.put(`/products/${productId}/skus/${skuId}`, skuData);
      return response.data; // Retorna { success, message }
    } catch (error) {
      console.error('❌ Error actualizando SKU:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando SKU');
    }
  },

  // Eliminar SKU de un producto
  deleteProductSku: async (productId, skuId) => {
    try {
      const response = await api.delete(`/products/${productId}/skus/${skuId}`);
      return response.data; // Retorna { success, message }
    } catch (error) {
      console.error('❌ Error eliminando SKU:', error);
      throw new Error(error.response?.data?.error || error.message || 'Error eliminando SKU');
    }
  }
};

export default productsService;
